import { connect } from 'react-redux';
import { searchHotels, selectHotel, favoriteHotel, editGroupEvent, selectEvent } from '../modules/tour';

import TourHotelSelectTab from './TourHotelSelectTab';

const mapDispatchToProps = {
  searchHotels,
  selectHotel,
  favoriteHotel,
  editGroupEvent,
  selectEvent,
};

const mapStateToProps = state => ({
  hotels: state.tours.hotels,
  selectedEvent: state.tours.selectedTour.selectedEvent,
});
const TourHotelSelectTabContainer = connect(mapStateToProps, mapDispatchToProps)(TourHotelSelectTab);
export default TourHotelSelectTabContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/TourHotelSelectTabContainer.js